<template>
    <b-card>
        <div v-if="loading">
            <b-spinner label="Loading..."></b-spinner>
        </div>
        <div v-else-if="infoData">
            <b-row>
                <b-col md="5">
                    <b-card-img rounded center fluid :src="infoData.imagen"></b-card-img>
                    </b-col>
                <b-col md="7">
                    <b-row>
                        <p class="item-name mb-0" style="font-size: 21px">{{infoData.nombre}}</p>
                    </b-row>
                    <b-row class="color-personalized">
                        <b-col md="6">
                            <b-row no-gutters class="px-1">
                                <b-col cols="6" class="text-left">
                                    Referencia:
                                </b-col>
                                <b-col cols="6" class="text-right">
                                    {{infoData.codigo}}
                                </b-col>
                            </b-row>
                            <b-row no-gutters class="row-background-personalized px-1">
                                <b-col cols="6" class="text-left">
                                    Código de Barras: 
                                </b-col>
                                <b-col cols="6" class="text-right">
                                    {{infoData.codigo_barras}}
                                </b-col>
                            </b-row>
                            <b-row no-gutters class="px-1" v-if="user.tipo_terceros == 1">
                                <b-col cols="6" class="text-left">
                                    Existencia Proveedor: 
                                </b-col>
                                <b-col cols="6" class="text-right">
                                    <template v-if="user.isMaster">
                                        <b>{{ infoData.quantity }}</b>
                                    </template>
                                    <template v-else>
                                        <b :class="$getSimpleStockClass(infoData.quantity)">{{ $getSimpleStockMessage(infoData.quantity) }}</b>
                                    </template>
                                </b-col>
                            </b-row>
                            <b-row no-gutters class="row-background-personalized px-1" v-if="show_supplier_price && user.isMaster">
                                <b-col cols="6" class="text-left">
                                    Precio Proveedor con Imp: 
                                </b-col>
                                <b-col cols="6" class="text-right">
                                    <strong>$ {{ numberFormat(infoData.precio_final_prov_imp) }}</strong>
                                </b-col>
                            </b-row>
                            <b-row no-gutters class="px-1">
                                <strong v-if="infoData.precio_personalizado == 2" >DC</strong>
                            </b-row>
                            <b-row v-if="infoData && infoData.prices_by_quantity_array.length > 0">
                                <b-col>
                                    
                                        <b>Precio por Volumen de Compra:</b>
                                        <div v-for="(price, index) in infoData.prices_by_quantity_array" :key="index">
                                            <ul>
                                                <li>
                                                    <b>{{price.quantity}}</b> unidades: 
                                                    <span class="price-item-quantities"> ${{numberFormat(price.precio_final_con_imp)}} </span>
                                                </li>
                                            </ul>
                                        </div>
                                    

                                </b-col>
                            </b-row>
                        </b-col>
                        <b-col md="6">
                            <b-row no-gutters>
                                <b-col cols="6" class="text-left">
                                    Precio:
                                </b-col>
                                <b-col cols="6" class="text-right">
                                    <b class="item-price">
                                        $ {{ numberFormat(infoData.precio_final_con_imp) }} COP
                                    </b>
                                </b-col>
                            </b-row>
                            <b-row no-gutters class="pb-2">
                                <b-col class="text-right">
                                    <p v-if="infoData.tax_rate !== 0">
                                        Iva incluido
                                    </p>
                                    <p v-else>
                                        No Incluye Iva
                                    </p>
                                </b-col>
                            </b-row>
                            <b-row no-gutters class="pb-2">
                                <b-col cols="6">
                                    <b-form-input
                                        v-model="cantidad"
                                        type="number"
                                        required
                                        placeholder="Cantidad"
                                        ></b-form-input>
                                </b-col>
                                <b-col cols="6" class="text-right" >
                                    <b-button type="submit" variant="success" v-if="checkItemExistenceAndPrice(infoData)"
                                    @click.prevent="addItemToCart(cantidad, infoData)">
                                        Agregar
                                    </b-button>

                                    <div class="producto-agotado" v-else><strong>Producto Agotado</strong></div>
                                </b-col>
                            </b-row>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <b-card no-body class="card-personalized">
                        <b-tabs card>
                        <b-tab title="Descripción" active>
                            <b-card-text v-if="infoData.descripcion_larga" v-html="infoData.descripcion_larga">
                                {{infoData.descripcion_larga}}
                            </b-card-text>
                            <b-card-text v-else>
                                No se ha ingresado una descripción para el producto
                            </b-card-text>
                        </b-tab>
                        </b-tabs>
                    </b-card>
                </b-col>
            </b-row>
        </div>
        <div v-else>
            <b-col>
                <b-alert variant="danger" show>
                    Lo sentimos, no se han encontrado resultados para su busqueda.
                </b-alert>
            </b-col>
        </div>
    </b-card>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
export default {
    data(){
        return{
            infoData: {},
            cantidad: 1,
            loading: true,
        }
    },
    created(){
        this.getItemDetail()
        .then((data) => {
            this.setLoading(true)
            this.infoData = data;
        })
        .catch((error) => {
            console.error('Error al cargar datos:', error);
        })
        .finally(() => {
            this.loading = false;
            this.setLoading(false)
        });
    },
    computed:{
        ...mapState('auth', ['user']),
        ...mapState('configuration', ['show_supplier_price']),
    },
    methods: {
        ...mapMutations(['setLoading']),
        ...mapActions('configuration', {
          _getCartCount: 'getCartItemsCountByUser',
        }),
        checkItemExistenceAndPrice(item) {
            return (
                 item.quantity > 0 && item.precio_final_con_imp > 0
            );
        },
        async getItemDetail() {
            try {
                const response = await this.$conectar.post('/busqueda/get-item-detail', { referencia: this.$route.params.referencia });
                return response.data.item;
            } catch (error) {
                console.error('Error al cargar datos:', error);
                throw error;
            }
        },
        volver(){
            this.$router.go(-1);
        },
        async addItemToCart(data, item){
            this.setLoading(true)
            await this.$conectar.post('/articulos/add-item-to-cart', { cantidad: data, referencia: item.codigo, quantity: item.quantity})
            .then(response =>{
                 if (response.data.error == false) { 
                    this._getCartCount();
                    this.$root.$bvToast.toast(response.data.mensaje, {
                        title: "Respuesta del servidor",
                        variant: "success",
                        solid: true
                    })
                }else{
                    this.$root.$bvToast.toast(response.data.mensaje, {
                        title: "Respuesta del servidor",
                        variant: "danger",
                        solid: true
                    })
                }
            })
            .catch(error => {
                this.$bvToast.toast("Parece que hubo un error en el servidor", {
                    title: "Respuesta del servidor",
                    variant: "danger",
                    solid: true
                })
                console.log(error);
            })
            this.setLoading(false);
            this.cantidad = 1;
        }
    }
}
</script>
<style scoped>
.card-img { 
    max-width: 100%; 
    max-height: 400px;
    object-fit: scale-down;
}
.color-personalized {
    background: #dcdde1 !important;
}

.singleLine {
  white-space: nowrap !important;
  overflow: hidden !important;
}
.card-personalized {
  min-height: 200px;
}
.row-background-personalized{
    background: white!important;
}

.producto-agotado{
    font-size: 18px;
    color: red;
}
</style>